import CompanyPricing from '../model/companyPricing'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchCompanyPricings(companyID: string): Promise<RequestResponse<CompanyPricing[]>> {
  return secureRequest('GET', url('/v2/companyPricings/' + companyID))
}
